import { useAuth } from "@/hooks/useAuth";
import { getInitials, getDisplayName } from "@/components/utils/avatar-colors";

export const useUserAvatar = () => {
  const { user, userData } = useAuth();

  const getAvatarUrl = () => {
    // Return avatar_url from user data already stored in context
    return userData?.avatar_url || null;
  };

  const getInitialsFromUser = () => {
    if (userData?.first_name && userData?.last_name) {
      return getInitials(userData.first_name, userData.last_name);
    }
    if (user?.email) {
      return user.email.substring(0, 2).toUpperCase();
    }
    return 'U';
  };

  const getDisplayNameFromUser = () => {
    if (userData?.first_name && userData?.last_name) {
      return getDisplayName(userData.first_name, userData.last_name);
    }
    return 'Utente';
  };

  return {
    avatarUrl: getAvatarUrl(),
    initials: getInitialsFromUser(),
    displayName: getDisplayNameFromUser(),
    userProfile: userData // Return the already stored user data
  };
}; 